import { useAuthContext } from '@aibees/shared/auth';
import { MemberType } from '@aibees/shared/definition';
import { useWorkspace } from '../context';

export function useIsOwner() {
  const { user } = useAuthContext();
  const workspace = useWorkspace();

  const isOwner = workspace?.user.id === user?.id;

  const isAdmin = workspace?.members.find(
    (x) => x.user?.id === user?.id && x.type === MemberType.Admin
  );

  return { isOwner, isAdmin };
}
